import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const getSlotList = async () => {
    try {
        const response = await api.get(API_END_POINTS.GET_SLOT_CONFIGURATION);
        const data = response.data;
        
        if (data?.errorCode === 200) {
            return data.responseData || [];
        }
        if (Array.isArray(data)) {
            return data;
        }

        throw new Error(data.errorMessage || "Failed to fetch slot list");
    } catch (error) {
        console.error("Error fetching slot list:", error);
        throw error;
    }
};

export const addSlotConfiguration = async (payload) => {
    try {
        const response = await api.post(API_END_POINTS.ADD_SLOT_CONFIGURATION, payload);
        const data = response.data;

        if (data.errorCode === 200) {
            return data.responseData;
        } else {
            throw new Error(data.errorMessage || 'Failed to add slot configuration');
        }
    } catch (error) {
        console.error('Error adding slot configuration:', error);
        throw error;
    }
};

export const removeSlotConfiguration = async (payload) => {
    try {
        const response = await api.post(API_END_POINTS.REMOVE_SLOT_CONFIGURATION, payload);
        const data = response.data;

        if (data.errorCode === 200) {
            return data.responseData;
        } else {
            throw new Error(data.errorMessage || 'Failed to remove slot configuration');
        }
    } catch (error) {
        console.error('Error removing slot configuration:', error);
        throw error;
    }
};